import { consentDocumentHref } from '@galapagos/shared';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { useSignupApi } from './useSignupApi';

/**
 * The link for the disclosure-of-data (Part 2 release) consent. Once the
 * member is signed in it is the API's preview stamped with their name. Before
 * the account exists the preview is not available, so until it resolves, and
 * whenever it fails, the link is the blank release this app publishes: the
 * same text, so a visitor can always read what they agree to.
 */
export function useDisclosureConsentLink(): string {
  const api = useSignupApi();
  const scenario = useSearchParams().get('scenario');
  const preview = useQuery({
    queryKey: ['signup', 'consent-preview', 'part2_release', scenario],
    queryFn: () => api.previewConsentDocument('part2_release'),
    retry: false,
  });
  return preview.data?.url ?? consentDocumentHref('part2_release');
}
